/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const FOR_USER_ID = 'forUserId';
export const FOR_USER_SESSION = 'forUserSession';

export const SESSION_ERROR_ACTION = 'SESSION_ERROR_ACTION';
export const LOCK_ORDER_ACTION = 'LOCK_ORDER_ACTION';
export const LOCK_ORDER_ERROR = ['_ERR_ORDER_IS_NOT_LOCKED', '_ERR_ORDER_IS_LOCKED'];
export const PARENT_IFRAME = 'parentIFrame';
export const IFRAME_RESIZER = 'iFrameResizer';
export const CART_FETCHING_REQUESTED = 'CART_FETCHING_REQUESTED';

/**
 * if updating/changing usage of/around this regex, `interceptedFetch.js` should also be updated
 */
export const RE = /^\/((api\/(search|resources))|((search|wcs)\/resources))\//;
